import settings from './settings';
import { authHeader } from './authHeader';
import { authService } from './authService';


export function getAttendances(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}attendances`, requestOptions).then(authService.handleResponse);
}

export function getMarkedAttendances(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${settings.API_URL}markedAttendance/${id}`, requestOptions).then(authService.handleResponse);
}


export function addAttendance(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}addAttendance`, requestOptions).then(authService.handleResponse);
}

export function editAttendance(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}update_attendance/${data.id}`, requestOptions).then(authService.handleResponse);
}


export function getAttendance(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${settings.API_URL}attendance/${id}`, requestOptions).then(authService.handleResponse);
}
